// extracted by mini-css-extract-plugin
module.exports = {"prod_switcher__div":"ProdSwitcherAttention_prod_switcher__div__3-KAC","prod_switcher__hide":"ProdSwitcherAttention_prod_switcher__hide__VepbU"};